import { connect } from 'react-redux';

const mapStateToProps = ((state) => {
    const labels = state.get('labels');

    return {
    
        getLabel: (key, defaultValue = "", vars = {}) => {

            if(defaultValue === ""){
                defaultValue = key;
            }
            let label = defaultValue;

            if (labels !== undefined && labels.get(key) !== undefined) {
                label = labels.get(key);
            }

            if (key === null || key === undefined) {
                label = defaultValue;
            }

            for (var varKey in vars) {
                if (vars.hasOwnProperty(varKey)) {
                    label = label.replace(new RegExp(`%{${varKey}}`, 'g'), vars[varKey]);
                }
            }

            return label;
        }

    };
})

const mapDispatchToProps = () => ({})

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => ({
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps
})

const applyLabel = (WrappedComponent) => connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(WrappedComponent);

export default applyLabel;